export interface Survey {
  id: number;
  questions: SurveyQuestion[];
}

export interface SurveyQuestion {
  text: string;
  description: string;
  video: string;
  icon: string;
  answer: number;
  timeTaken: number;
}

export interface AnswerOption {
  text: string;
  value: number;
}

export interface SurveyAnswer {
  AnswerId: number;
  Q1: number;
  Q2: number;
  Q3: number;
  Q4: number;
  Q5: number;
  Q1TT: number;
  Q2TT: number;
  Q3TT: number;
  Q4TT: number;
  Q5TT: number;
  IsOnDemand?: boolean;
}

export interface Score {
  score: number;
  createdOn: string;
}

export interface WellbeingInterval {
  start: number;
  end: number;
  minScore: number;
  maxScore: number;
  color: number;
}

export interface SurveyIntervention {
  title?: string;
  body: string;
  disclaimer?: string;
  color?: number;
  showContactMeButton?: boolean;
  showUnpauseMeButton?: boolean;
  markdown?: string | null;
  intervention: number | boolean;
  showAddNoteButton?: boolean;
  scores?: Score[];
  styles?: null;
  isOnDemand?: boolean;
  wellbeingIntervals?: WellbeingInterval[];
  bodyAnswers?: BodyAnswer[];
}

export interface BodyAnswer {
  finishedOn: string;
  answers: {
    key: string;
    intAnswer: number;
    finishedOn: string;
  }[];
}

export interface BodyPrefill {
  BodyAnklesFeetLeft?: number;
  BodyAnklesFeetRight?: number;
  BodyElbowsLeft?: number;
  BodyElbowsRight?: number;
  BodyHipsThighs?: number;
  BodyKneesLeft?: number;
  BodyKneesRight?: number;
  BodyLowerback?: number;
  BodyNeck?: number;
  BodyShouldersLeft?: number;
  BodyShouldersRight?: number;
  BodyUpperback?: number;
  BodyWristsHandsLeft?: number;
  BodyWristsHandsRight?: number;
}

export interface SurveySessionAnswer {
  ManagerRecipients?: number[];
  HrRecipients?: number[];
  IsAnonymous: boolean;
  SingledOutHr: boolean;
  Answers?: Record<string, number | string | null>;
  OnDemand: boolean;
}

export enum SurveySessionState {
  Offered = 0,
  Started = 1,
  Finished = 2
}

export interface SurveySession {
  surveySessionId: number;
  steps: {
    type: SurveyDefinitionStepType;
    key: string;
    labels: {
      [key: string]: string;
    };
    answerOptions: any;
  }[];
}

export enum SurveyDefinitionStepType {
  CoverPage = 1,
  QuestionWithOptionSetSingleSelection = 2,
  QuestionWithText = 3,
  Body = 4,
  ThankYou = 99,
}

export interface NoteToResponseTeam {
  id: number;
  note: string;
}

export interface NoteModelResponse {
  id: number;
  title: string;
  content: string;
}
